import React from 'react';
import Link from '@atlaskit/link';
import InlineMessage from '@atlaskit/inline-message';
import { fg } from '@atlassian/jira-feature-gating';
import { defineMessages, useIntl } from '@atlassian/jira-intl';

const i18n = defineMessages({
	title: {
		id: 'locationless-dialog-v2.error-message-secondary-text',
		defaultMessage: 'Something went wrong setting the location',
		description: '',
	},
	message: {
		id: 'locationless-dialog-v2.error-message-text',
		defaultMessage: 'You can try again or get help ',
		description: '',
	},
	here: {
		id: 'locationless-dialog-v2.error-message-here-link-text',
		defaultMessage: 'here',
		description: '',
	},
});

function ErrorMessage(): React.JSX.Element {
	const intl = useIntl();

	return (
		<InlineMessage title={intl.formatMessage(i18n.title)} appearance="error">
			{intl.formatMessage(i18n.message)}
			{fg('replace-anchor-with-link__a4t-pandora') ? (
				<Link
					href="https://support.atlassian.com/contact/"
					rel="noopener noreferrer"
					target="_blank"
				>
					{intl.formatMessage(i18n.here)}
				</Link>
			) : (
				// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
				<a href="https://support.atlassian.com/contact/" rel="noopener noreferrer" target="_blank">
					{intl.formatMessage(i18n.here)}
				</a>
				// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
			)}
			.
		</InlineMessage>
	);
}

export default ErrorMessage;
